import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { COMMUNICATION_PURPOSES } from '@/lib/constants';
import { DataItem, DropdownPicker } from '../dropdown-picker';

export const DropdownSubcategory: FC<
  Omit<
    ComponentProps<typeof DropdownPicker>,
    'data' | 'emptyLabel' | 'control' | 'search'
  >
> = (props) => {
  const { t } = useTranslation();

  const subcategories: DataItem[] = COMMUNICATION_PURPOSES.reduce(
    (acc, purpose) => {
      const arr = purpose.subcategories.map(({ i18nKey, value }) => ({
        value,
        text: t(i18nKey),
      }));
      return acc.concat(arr);
    },
    [] as DataItem[]
  );

  return (
    <DropdownPicker
      {...props}
      emptyLabel={t('label.subcategory')}
      data={subcategories}
      control="checkbox"
      search
    />
  );
};
